module.exports = __webpack_public_path__ + "static/media/fold_line_small_on.b5dcfe68.svg";